import { Box, IconButton, Modal, Typography } from '@mui/material';
import { ClearIcon } from '@mui/x-date-pickers';
import { CouponBanner } from '@/components/blocks/EmailRecommendedCouponPopup/parts/CouponBanner';
import { ProductItem } from '@/components/blocks/EmailRecommendedCouponPopup/parts/ProductItem';
import { ProductItemSkeleton } from '@/components/blocks/EmailRecommendedCouponPopup/parts/ProductItemSkeleton';
import { PopupActions } from '@/components/blocks/EmailRecommendedCouponPopup/parts/PopupActions';
import { PopupDialogProps } from '@/components/blocks/EmailRecommendedCouponPopup/parts/types';
import {
	closeButtonSX,
	contentSX,
	dialogContainerSX,
	modalRootSX,
	modalSX,
	productListSX,
	titleSX,
} from '@/components/blocks/EmailRecommendedCouponPopup/styles';

export const PopupDialog = ({
	open,
	loading = false,
	actionsDisabled = false,
	skeletonCount = 3,
	title,
	couponCode,
	couponLabel,
	couponExpiry,
	couponLoginMessage = 'Inicia sesión para desbloquear tu descuento en este look.',
	products,
	productsSelected,
	isLoggedIn,
	onClose,
	onToggleCheckProduct,
	onSelectChildrenProduct,
	onAddToCart,
	onGoToCheckout,
}: PopupDialogProps) =>
	open ? (
		<Modal
			slotProps={{
				root: {
					sx: modalRootSX,
				} as any,
			}}
			sx={modalSX}
			open={open}
			onClose={onClose}
		>
			<Box sx={dialogContainerSX}>
				<IconButton color="inherit" onClick={onClose} sx={closeButtonSX} aria-label="Cerrar">
					<ClearIcon color="inherit" fontSize="inherit" />
				</IconButton>

				<Box sx={contentSX}>
					<Typography component="h2" sx={titleSX}>
						{`PIEZAS SELECCIONADAS PARA TUS ${title}`}
					</Typography>

					<CouponBanner
						code={couponCode}
						label={couponLabel}
						expiry={couponExpiry}
						loginMessage={couponLoginMessage}
						isLoggedIn={isLoggedIn}
					/>

					<Box sx={productListSX}>
						{loading
							? Array.from({ length: skeletonCount }).map((_, index) => (
									<ProductItemSkeleton key={index} />
							  ))
							: products.map((product) => (
									<ProductItem
										key={product.partNumber}
										product={product}
										checked={Object.keys(productsSelected).includes(product.partNumber)}
										selectedChild={productsSelected[product.partNumber] ?? null}
										onToggle={onToggleCheckProduct}
										onSelectSize={onSelectChildrenProduct}
									/>
							  ))}
					</Box>

					<PopupActions
						disabled={loading || actionsDisabled}
						isLoggedIn={isLoggedIn}
						onAddToCart={onAddToCart}
						onGoToCheckout={onGoToCheckout}
					/>
				</Box>
			</Box>
		</Modal>
	) : null;
